import { TRIAL_MODULE_KEYS, type TrialModuleKey } from '../types';

const CANONICAL_SET = new Set<string>(TRIAL_MODULE_KEYS);

/** Pre–14-tile keys; node-api maps these on create-trial — keep in sync with `modules-of-interest.ts`. */
const LEGACY_TO_CANONICAL: Record<string, TrialModuleKey | TrialModuleKey[]> = {
  onboarding: 'onboarding',
  academy: 'elearning',
  forms: 'forms',
  surveys: 'surveys',
  performance: 'performance',
  communication: ['news', 'chat'],
  knowledge: 'kb',
  events: 'events',
};

function resolveInputKey(raw: string): TrialModuleKey[] {
  const key = raw.trim().toLowerCase();

  if (CANONICAL_SET.has(key)) {
    return [key as TrialModuleKey];
  }

  const legacy = LEGACY_TO_CANONICAL[key];

  if (!legacy) {
    return [];
  }

  return Array.isArray(legacy) ? legacy : [legacy];
}

export function normaliseModulesOfInterest(
  raw: string[] | null | undefined,
): TrialModuleKey[] {
  if (!raw?.length) {
    return [];
  }

  const seen = new Set<TrialModuleKey>();
  const ordered: TrialModuleKey[] = [];

  raw.forEach((item) => {
    resolveInputKey(item).forEach((canonical) => {
      if (!seen.has(canonical)) {
        seen.add(canonical);
        ordered.push(canonical);
      }
    });
  });

  return ordered;
}
